export default __webpack_public_path__ + "static/media/template.19f9fe49.svg";